import * as Yup from "yup";


export const BusinessFormTitleValidation = Yup.object().shape({
    title:Yup.string().required('Title is required')
});


export const BusinessFormInformationValidation = Yup.object().shape({
    information: Yup.object().shape({
           name: Yup.string().required('required'),
           address: Yup.string().required('required'),
           contact: Yup.string().required('required'),
           email: Yup.string().required('required'),
           website: Yup.string(),
       }),
});


export const BusinessFormDetailsValidation = Yup.object().shape({
     details: Yup.object().shape({
            is_registered: Yup.string().required('This field is required'),
            registration_number: Yup.string(),
            tax_registration_number: Yup.string(),
            is_new: Yup.string().required('Business First Name is required'),
            business_type: Yup.string().required('Business Type is required'),
        }),
});


export const BusinessFormCategoryValidation = Yup.object().shape({
    category: Yup.object().shape({
            service_type: Yup.string().required('Business Service Type is required'),
            category: Yup.string().required('Business Category is required'),
            years: Yup.number(),
            target_market: Yup.string()
       })
});


export const BusinessFormProductServiceValidation = Yup.object().shape({
    products_services:  Yup.array().of(Yup.object().shape({
                   type:Yup.string().required(),
                   name:Yup.string().required(),
                   description:Yup.string().required()
                }))

});

export const BusinessFormRequiredAssistanceValidation = Yup.object().shape({
    required_assistance: Yup.object().shape({
            assistance: Yup.array().of(Yup.string()).required('Please select required services'),
            expos_assistance: Yup.string(),
       })
});

export const BusinessFormExpectationValidation = Yup.object().shape({
    expectation_of_sbaj: Yup.string()
});

export const BusinessFormOtherInformationValidation = Yup.object().shape({
    other_information: Yup.object().shape({
             committee_service:Yup.string(),
             how_did_you_find_us:Yup.string(),
             list_in_directory: Yup.string(),
             other_employment:Yup.string(),
             specify:Yup.string(),
             area_of_expertise:Yup.string()
       })
});

// export const BusinessFormPaymentValidation = Yup.object().shape({
//     payment: Yup.any();
// });